// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__NWRLv","content":"Consent_content__21Lto","footer":"Consent_footer__11Nr2"};